module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/bg-04-abde719363bbb7187e9e3539cfa75ed7.png";